// Red Dune — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

// ── NAV-HISTORIC: the workspace swap's one-time move of a remembered choice ──
// Since the swap (../customs/navigation/historic.mjs) the site's MAIN bar is NEW (Settings only) and HISTORIC
// is the extra workspace `historic`. A browser that remembered "main" before the swap remembered the OLD
// HISTORIC bar — after the swap that would open an empty bar. So, once per browser (the marker), a remembered
// "main" becomes "historic"; a choice made after that (even "main" = NEW) is never touched again. This module
// is evaluated before the shell's useWorkspaces reads the key (it imports BRAND_NAME from here). Node also
// imports this file (web/vite.config.js, the config suite): no window there, nothing happens.
// THE SWAP BACK (at switch-over, when NEW leaves MAIN and HISTORIC is retired): change WORKSPACE_SWAP to
// { from: 'historic', to: 'main', marker: 'red-dune:ws-swap-back-v1' } in the same release as the bars.
export const WORKSPACE_SWAP = Object.freeze({ key: 'stride.workspace', from: 'main', to: 'historic', marker: 'red-dune:ws-swap-v1' });
export function migrateWorkspaceChoice(storage, swap = WORKSPACE_SWAP) {
  try {
    if (!storage || storage.getItem(swap.marker)) return false;
    const moved = storage.getItem(swap.key) === swap.from;
    if (moved) storage.setItem(swap.key, swap.to);
    storage.setItem(swap.marker, '1');
    return moved;
  } catch {
    return false; // storage blocked (private window, quota): the product's own rule picks the bar
  }
}
if (typeof window !== 'undefined') {
  try { migrateWorkspaceChoice(window.localStorage); } catch { /* no storage: nothing to move */ }
}

export const BRAND_NAME = 'Red Dune';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Red Dune — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;
export const STORAGE_PREFIX = 'red-dune';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'LINK';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 219, g: 19, b: 36 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// The fork's own views of fields on the work item screen (the product's FIELD_VIEWS seam,
// modules/database/work-items/frontend/components/FieldView/fieldViews.js). Frontend only: the
// server seam has no twin of it.
//   Original estimate (timeoriginalestimate, on the Red Dune Generic Screen's Details) → Jira's time
//   tracking: the bar, Original estimate in Jira's words, Log work and the Work log
//   (../customs/work-log/, saved by ../customs/server/work-log.js).
export const FIELD_VIEWS = [
  { field: 'timeoriginalestimate', label: 'Time tracking', load: () => import('@client/customs/work-log/TimeTrackingField.jsx') },
];
